module.exports = __webpack_public_path__ + "24318d1f1e636939423bb0d195a5b1df.png";